
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMsiIec as ObiMsiIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-msi-iec.js';
 
 
 

 
 export const ObiMsiIec = createComponent({
   react: React,
   tagName: 'obi-msi-iec',
   elementClass: ObiMsiIecElement,
   events: {
     
   }
  });
 
 